import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "gatsby";
import React from "react";

import { clientUrl } from "../../constants/site-urls";
import { useReferrer } from "../../hooks/use-referrer";
import Logo from "../logo";

const navigation = [
  { name: "Templates", href: `${clientUrl}` },
  { name: "Ebook", href: `${clientUrl}/ebook` },
  { name: "Blog", to: "/blog" },
  { name: "Documentation", to: "/documentation" },
];

const Header = ({ absolute = false, bottomBorder = true }) => {
  useReferrer();

  return (
    <div className={absolute ? "absolute top-0 left-0 right-0 z-50" : ""}>
      <div className="bg-emerald-500">
        <div className="mx-auto max-w-7xl text-sm text-center text-white p-2 sm:px-6 lg:px-8">
          Want to learn all about Chrome Extension development fundamentals?
          Take a look at our new course!{" "}
          <Link
            className="underline ml-2"
            to="/blog/chrome-extension-basics-course"
          >
            Learn More &rarr;
          </Link>
        </div>
      </div>
      <div>
        <Disclosure as="nav" className={absolute ? "" : "bg-white"}>
          {({ open }) => (
            <>
              <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div
                  className={bottomBorder ? "border-b border-slate-200" : ""}
                >
                  <div className="flex py-4 items-center justify-between px-4 sm:px-0">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 border-r border-slate-200 pr-6">
                        <Link to="/">
                          <Logo className="h-auto" style={{ width: 150 }} />
                        </Link>
                      </div>
                      <div className="hidden md:block">
                        <div className="ml-4 flex items-baseline space-x-4">
                          {navigation.map((item) =>
                            item.to ? (
                              <Link
                                key={item.name}
                                to={item.to}
                                className="text-slate-500 px-3 py-2 text-sm font-medium hover:text-emerald-500"
                              >
                                {item.name}
                              </Link>
                            ) : (
                              <a
                                key={item.name}
                                href={item.href}
                                className="text-slate-500 px-3 py-2 text-sm font-medium hover:text-emerald-500"
                                aria-current={item.current ? "page" : undefined}
                              >
                                {item.name}
                              </a>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="hidden md:block">
                      <div className="ml-4 flex items-center md:ml-6">
                        {/* Profile dropdown */}
                        <div className="items-center justify-end md:flex md:flex-1 lg:w-0">
                          <a
                            href={`${clientUrl}/login`}
                            className="whitespace-nowrap text-sm font-medium text-slate-500 hover:text-slate-900"
                          >
                            Sign in
                          </a>
                          <Link
                            to="/checkout"
                            className="ml-8 inline-flex items-center justify-center whitespace-nowrap rounded-md border border-transparent bg-emerald-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-emerald-600"
                          >
                            Get all access &rarr;
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="flex md:hidden">
                      {/* Mobile menu button */}
                      <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-slate-100 p-2 text-slate-500 hover:bg-slate-200 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-400">
                        <span className="sr-only">Open main menu</span>
                        {open ? (
                          <XMarkIcon
                            className="block h-6 w-6"
                            aria-hidden="true"
                          />
                        ) : (
                          <Bars3Icon
                            className="block h-6 w-6"
                            aria-hidden="true"
                          />
                        )}
                      </Disclosure.Button>
                    </div>
                  </div>
                </div>
              </div>

              <Disclosure.Panel className="border-b border-slate-200 px-6 bg-white md:hidden">
                <div className="space-y-1 py-3">
                  {navigation.map((item) =>
                    item.to ? (
                      <Disclosure.Button
                        key={item.name}
                        as={Link}
                        to={item.to}
                        className="text-slate-500 hover:text-slate-900 block py-2 text-base font-medium"
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </Disclosure.Button>
                    ) : (
                      <Disclosure.Button
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="text-slate-500 hover:text-slate-900 block py-2 text-base font-medium"
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </Disclosure.Button>
                    )
                  )}
                </div>
                <div className="border-t border-slate-200 pt-4 pb-3">
                  <div>
                    <Link
                      to="/checkout"
                      className="flex w-full items-center justify-center rounded-md border border-transparent bg-emerald-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-emerald-700"
                    >
                      Get all access
                    </Link>
                    <p className="mt-6 text-center text-base font-medium text-slate-500">
                      Existing customer?
                      <a
                        href={`${clientUrl}/login`}
                        className="ml-1 text-emerald-600 hover:text-emerald-500"
                      >
                        Sign in
                      </a>
                    </p>
                  </div>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  );
};

export default Header;
